import { RichText, useBlockProps } from "@wordpress/block-editor";
import React from "react";

interface SaveProps {
    attributes: {
        label?: string;
    };
}

const Save: React.FC<SaveProps> = ({ attributes: { label } }) => {
    return (
        <button {...useBlockProps.save()} aria-label="Menü öffnen">
            <RichText.Content value={label} />
        </button>
    );
};

export default Save;
